module.exports = __webpack_public_path__ + "static/media/best-taste.3cfc505f.png";